import React, { ComponentProps } from 'react';

import classNames from 'classnames';
import { Tooltip } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import styles from './info-tooltip.module.scss';

type TooltipConfigProps = ComponentProps<typeof Tooltip> & { icon?: React.ReactNode };

export function getInfoTooltipConfig(props: TooltipConfigProps): TooltipConfigProps {
	return {
		...props,
		overlayClassName: styles.infoTooltip,
		icon: <BringgIcon iconName={BringgFontIcons.Info} className={styles.infoTooltipIcon} />
	};
}

type InfoTooltipProps = ComponentProps<typeof Tooltip> & {
	iconClassName?: string;
};

export const InfoTooltip = ({ iconClassName, overlayClassName, ...rest }: InfoTooltipProps) => (
	<Tooltip {...rest} overlayClassName={classNames(styles.infoTooltip, overlayClassName)}>
		<BringgIcon iconName={BringgFontIcons.Info} className={classNames(styles.infoTooltipIcon, iconClassName)} />
	</Tooltip>
);
